import type {
  SearchFilters,
  SearchMultiSelectFilters,
  SearchMultiSelectFilterType,
  SearchSelectFilters,
  SearchSelectFilterType,
  SelectedMultiOptionValues,
  SelectedOptionValue,
} from '@/scopes/search/search/infrastructure/api/types'
import type { FilterOption } from '@/scopes/search/types'

export function getMultiSelectFilterSelectedOption<K extends SearchMultiSelectFilterType>(filtersData: Partial<SearchMultiSelectFilters>, filterType: SearchMultiSelectFilterType, filterSelectedValues: SelectedMultiOptionValues<SearchFilters[K]>): FilterOption<string>[] {
  const filter = filtersData[filterType]
  if (!filter || !filterSelectedValues)
    return []

  const { options } = filter
  const filterSelectedValuesLowerCase = Array.isArray(filterSelectedValues) ? filterSelectedValues?.map((value: string) => value.toLowerCase()) || [] : [filterSelectedValues]
  return options.reduce<FilterOption<string>[]>(
    (acc, option) => (!filterSelectedValuesLowerCase.includes(option.value.toLowerCase()) ? acc : [...acc, option]),
    [],
  )
}

export function getSelectFilterSelectedOption<K extends SearchSelectFilterType>(filtersData: Partial<SearchSelectFilters>, filterType: SearchSelectFilterType, filterSelectedValue: SelectedOptionValue<SearchFilters[K]> | null): FilterOption<string> | null {
  const filter = filtersData[filterType]

  if (!filter)
    return null

  const { options } = filter

  if (!filterSelectedValue)
    return null

  return options.find(option => filterSelectedValue === option.value) || null
}
